
import { mapGetters } from "vuex";
export default {
  props: {
    order: {
      default: {}
    }
  },
  data() {
    return {
      secondsInCurrentStage: 0,
      configuredHealth: 0,
      healthInSeconds: 0,
      timer: null
    };
  },
  mounted() {
    this.calculateSecondsInCurrentStage();
    this.timer = setInterval(() => {
      this.calculateSecondsInCurrentStage();
    }, 1000);
  },
  computed: {
    ...mapGetters("restaurant", ["hasMultipleBrands", "getRecieverSettings"]),
    isDispatchTimedOut() {
      const timeoutInHours = 4;
      return this.minutesSinceDispatched > timeoutInHours * 60;
    },
    loaderValue() {
      return (this.secondsInCurrentStage / this.configuredHealth) * 100;
    },
    loaderColor() {
      if (this.loaderValue >= 100) {
        return "#DA1717";
      } else if (this.loaderValue >= 66) {
        return "#FF4040";
      } else if (this.loaderValue >= 33) {
        return "#FFB340";
      } else {
        return "#47C54F";
      }
    }
  },
  methods: {
    calculateSecondsInCurrentStage() {
      let time, health;
      switch (this.order.status) {
        case this.$constants.OrderStatuses.NEW_ORDER.id:
          time = this.order.started_at;
          health = this.getRecieverSettings(
            this.order.restaurant_id
          ).health_metrics_order_acceptance_time;
          break;
        case this.$constants.OrderStatuses.PREPARING.id:
          time = this.order.accepted_at;
          health = this.order.order_preparation_time
            ? this.order.order_preparation_time * 60
            : this.getRecieverSettings(this.order.restaurant_id)
                .health_metrics_preparation_time;
          break;
        case this.$constants.OrderStatuses.READY_FOR_DELIVERY.id:
          time = this.order.ready_at;
          health = this.getRecieverSettings(
            this.order.restaurant_id
          ).health_metrics_pickup_time;
          break;
        case this.$constants.OrderStatuses.PICKED_UP.id:
          time = this.order.dispatched_at;
          health = this.getRecieverSettings(
            this.order.restaurant_id
          ).health_metrics_delivery_time;
          break;

        default:
          time = this.order.completed_at;
          health = 0;
          break;
      }
      this.secondsInCurrentStage = this.getDateTimeDifferenceInSeconds(time);
      this.configuredHealth = health;
      this.healthInSeconds = health - this.secondsInCurrentStage;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
